<template>
  <div class="achievement-section pe-section">
    <div class="main-container">
      <div class="title-container">
        <h2>{{ t("home.pebeautie.title") }}</h2>
      </div>

      <div class="subtitle">
        <p>{{ t("home.pebeautie.argsubtitle1") }}</p>
      </div>

      <div class="cards-container pe-container">
        <div class="card card-1" :class="{ active: activeCard === 1 }" @mouseenter="handleCardHover(1)">
          <div class="card-background">
            <img src="@/assets/image/home/home_ECM_1_normal.png" :alt="$t('home.pebeautie.card1Alt')" class="bg-image small-img" />
            <img src="@/assets/image/home/home_ECM_1.png" :alt="$t('home.pebeautie.card1Alt')" class="bg-image large-img" />
          </div>
          <div class="card-content">
            <div class="text-content">
              <h3>{{ $t("home.pebeautie.card1Title") }}</h3>
              <p>{{ $t("home.pebeautie.card1Desc") }}</p>
            </div>
          </div>
        </div>

        <div class="card card-2" :class="{ active: activeCard === 2 }" @mouseenter="handleCardHover(2)">
          <div class="card-background">
           <img src="../../assets/image/home/home_ECM_2_normal.png" :alt="$t('home.product.card2Alt')" class="bg-image small-img" /> 
           <img src="../../assets/image/home/home_ECM_2.png" :alt="$t('home.product.card2Alt')" class="bg-image large-img" /> 
          </div>
          <div class="card-content">
            <div class="text-content">
              <h3>{{ $t("home.pebeautie.card2Title") }}</h3>
              <p>{{ $t("home.pebeautie.card2Desc") }}</p>
            </div>
          </div>
        </div>

        <div class="card card-3" :class="{ active: activeCard === 3 }" @mouseenter="handleCardHover(3)">
          <div class="card-background">
            <img src="@/assets/image/home/home_ECM_3_normal.png" :alt="$t('product.card3Alt')" class="bg-image small-img" />
            <img src="@/assets/image/home/home_ECM_3.png" :alt="$t('product.card3Alt')" class="bg-image large-img" />
          </div>
          <div class="card-content">
            <div class="text-content">
              <h3>{{ $t("home.pebeautie.card3Title") }}</h3>
              <p>{{ $t("home.pebeautie.card3Desc") }}</p>
            </div>
          </div>
        </div>

        <div class="card card-4" :class="{ active: activeCard === 4 }" @mouseenter="handleCardHover(4)">
          <div class="card-background">
            <img src="@/assets/image/home/home_ECM_4_normal.png" :alt="$t('home.product.card4Alt')" class="bg-image small-img" />
            <img src="@/assets/image/home/home_ECM_4.png" :alt="$t('home.product.card4Alt')" class="bg-image large-img" />
          </div>
          <div class="card-content">
            <div class="text-content">
              <h3>{{ $t("home.pebeautie.card4Title") }}</h3>
              <p>{{ $t("home.pebeautie.card4Desc") }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";

const { locale, t } = useI18n();
const activeCard = ref(1);

const handleCardHover = (cardId) => {
  activeCard.value = cardId;
};

onMounted(() => {
  activeCard.value = 1;
});
</script>

<style scoped>
  @import "@/assets/css/product.css";
</style>